import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogRef } from '@angular/cdk/dialog';
import { UserData, UserDataFullPayload } from '../../../reservation.model';
import { ReservationSummaryApiService } from '../../services/reservation-summary-api.service';
import { InfoboxService } from '../../../../common/infobox/infobox.service';
import { DateService } from '../../../../common/date.service';
import { LoaderService } from '../../../../common/loader/loader.service';
import { ReservationService } from '../../../reservation.service';
import { ContactDestiny } from 'src/app/common/enums/ContactDestiny';

@Component({
	selector: 'app-reservation-summary-payments-userdata-dialog',
	templateUrl: './reservation-summary-payments-userdata-dialog.component.html',
	styleUrls: ['./reservation-summary-payments-userdata-dialog.component.scss'],
})
export class ReservationSummaryPaymentsUserdataDialogComponent implements OnInit {
	participantForm: FormGroup;
	regularCustomer: boolean;

	constructor(
		private readonly dialogRef: DialogRef,
		private readonly apiService: ReservationSummaryApiService,
		private readonly infobox: InfoboxService,
		private readonly dateService: DateService,
		private readonly loader: LoaderService,
		private readonly service: ReservationService,
	) {}

	ngOnInit(): void {
		this.participantForm = new FormGroup({
			sex: new FormControl(''),
			firstName: new FormControl(''),
			lastName: new FormControl(''),
			birth: new FormControl(''),
			phone: new FormControl('', [Validators.pattern(/^[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$/)]),
		});
	}

	protected getControlValue(controlName: string): string {
		return this.participantForm.get(controlName).value;
	}

	closeDialog() {
		this.dialogRef.close();
	}

	submit() {
		if (this.participantForm.invalid) {
			this.infobox.error('Wprowadzono niepoprawne dane!');
		}

		this.loader.show('payments-userdata-dialog');

		const { createUserDataFull } = this.apiService.actions();

		const payload: UserDataFullPayload = {
			birth: this.dateService.apiToDateTime(this.getControlValue('birth')).date,
			firstName: this.getControlValue('firstName'),
			lastName: this.getControlValue('lastName'),
			regularCustomer: this.regularCustomer,
			idNumber: '',
			sex: this.getControlValue('sex'),
			userAddresses: [],
			userConsent: [],
			userContacts: [],
			userDocuments: [],
		};

		const phoneNumber = this.getControlValue('phone');
		if (phoneNumber) {
			payload.userContacts.push({
				destiny: ContactDestiny.CONTACT,
				email: '',
				phone: phoneNumber,
			});
		}

		createUserDataFull(payload).then((result: UserData) => {
			this.service.newPayer = result;
			this.infobox.success('Pomyślnie utworzono nowego uczestnika w bazie!');
			this.closeDialog();
		});

		this.loader.hide('payments-userdata-dialog');
	}
}
